module.exports = __webpack_public_path__ + "img/mao-effect.7b6dcb55.svg";